export enum CategoryEnum {
  NOVA_FUNCIONALIDADE = 'NOVA_FUNCIONALIDADE',
  CORRECAO_DE_BUG = 'CORRECAO_DE_BUG',
  MELHORIA = 'MELHORIA',
}

export const CategoryEnumDisplay = {
  [CategoryEnum.NOVA_FUNCIONALIDADE]: 'Nova funcionalidade',
  [CategoryEnum.CORRECAO_DE_BUG]: 'Correção de bug',
  [CategoryEnum.MELHORIA]: 'Melhoria',
};


// WEBPACK FOOTER //
// /app/src/app/model/manage-versions/CategoryEnum.ts